import { Card, CardContent, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useCustomerAuth } from '../CustomerAuthContext';
import { useValidateSessionQuery } from '@features/customer-reservations/queries';

export const LoyaltyPointsBadge = () => {
  const intl = useIntl();
  const { isAuthenticated } = useCustomerAuth();
  const { data: sessionData } = useValidateSessionQuery(isAuthenticated);

  if (!sessionData?.loyaltyPoints || sessionData.loyaltyPoints <= 0) return null;

  return (
    <Card sx={{ bgcolor: 'primary.main' }}>
      <CardContent sx={{ py: 1, px: 2, '&:last-child': { pb: 1 } }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2" fontWeight={600} color="primary.contrastText">
            {intl.formatMessage({ id: 'customerAuth.loyaltyPoints' })}:
          </Typography>
          <Typography variant="h6" fontWeight={700} color="primary.contrastText">
            {sessionData.loyaltyPoints}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
